var price_mnu = {
	header_name		: 'Price Range',
  	header_key      : 'price',
  	type            : 'price',
  	sub_menu        : [
	{
	    menu_name   : '$0.00 - $50.00',
	    menu_key    : '0-50',
	},
	{
	    menu_name   : '$50.00 - $100.00',
	    menu_key    : '50-100',
	},
	{
	    menu_name   : '$100.00 - $250.00',
	    menu_key    : '100-250',
	},
	{
	    menu_name   : '$250.00 - $500.00',
	    menu_key    : '250-500',
	},
	{
	    menu_name   : '$500.00 <',
	    menu_key    : '500-@max_range',
	}
	]
}

var generate_filters = function(collection_name){
	var filters_ = [];
	
	switch(collection_name){
		case 'xc-gravel':
			filters_ = ['price_range'];
			break;
		/*case 'xc-gravel':
		case 'office-desks':
			filters_ = ['price_range'];
			break;*/
		
		default:
			filters_ = ['price_range'];
	
	}
	return filters_;
}